import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { uuid } from 'uuidv4';
import ImageSlider from '../../../../components/ImageSliderFast';
import { loadFromJson } from '../../../../utils/loadFromJson';
import { hash } from '../../../../config';
interface ISlide {
  id?: number;
  content: JSX.Element;
  key: string;
}


interface IProps {
  poster_id: string;

}

const SliderHeaderComponent: React.FC<IProps> = ({
  poster_id
}) => {

  const [sliders, setSliders] = useState([]);
  const [slidersKey, setSlidersKey] = useState('slider');

  const loadSliders = async () => {

    let data = [];

    const jsonData = await loadFromJson({ hash: hash, project_id: 'ondemand', table: 'LessonPoster' });

    if (jsonData) {
      data = jsonData?.[0]?.posters || [];
    }
    else {
      const response = await api.post(`/lesson-slides/list/ondemand`, { poster_id: poster_id });
      data = response.data;
    }



    setSlidersKey(uuid());
    setSliders(data);


  }

  useEffect(() => {



    loadSliders();



  }, [poster_id])


  return sliders.length > 0 ? <ImageSlider key={slidersKey} slides={sliders} /> : <></>
}

export default SliderHeaderComponent;